import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { ResourceAccessGuard } from '@tourfold/shared-kernels/resource-access';
import { SETTINGS_INJECTION_TOKENS } from '@tourfold/shared-kernels/settings-registry';
import { TagsSettings } from './settings-tags.component';

export function provideSettingsElementTags(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: SETTINGS_INJECTION_TOKENS,
      useValue: {
        path: 'tags',
        name: 'Tags',
        icon: 'pi pi-tag',
        component: TagsSettings,
        order: 6,
        translateName: 'SETTINGS_TAGS.TITLE',
        resource_key: 'tags',
        required_action: 'read',
        canActivate: [ResourceAccessGuard],
        category: {
          id: 'workspace',
          name: 'Workspace',
          order: 1,
          translateName: 'SETTINGS.CATEGORIES.WORKSPACE',
        },
      },
      multi: true,
    },
  ]);
}
